// axiosConfig.js
import axios from 'axios';
import {createBrowserHistory} from 'history';
import config from '../config';
import {getAccessToken, getRefreshToken} from "./auth";

const history = createBrowserHistory();

const axiosInstance = axios.create({
    baseURL: config.baseURL,
});

axiosInstance.interceptors.request.use(
    // add / to the end of request url if it does not exist already because of drf structure
    (config) => {
        if (config.url && !config.url.endsWith('/')) {
            config.url += '/';
        }
        const token = getAccessToken()
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.log(error);
        return Promise.reject(error);
    }
);

export {axiosInstance, history};
